export const environment = {
  development: false,
  production: false,
  staging: true,
  apiUrl: 'https://ires.irisunblur.com/api'
};
